import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'duotone-trash-svg-icon',
    templateUrl: 'duotone-trash-svg-icon.component.html',
    standalone: false
})

export class DuotoneTrashSvgIconComponent implements OnInit {
  constructor() { }

  ngOnInit() { }
}
